import "./assets/index.css";
import { useRef, useState } from "react";
import Textfield from "../../common/components/Textfiled";
import Button from "../../common/components/Button";
import SelectSearch from "../../common/components/SelectSearch";
import { useClaimsAndLegalCostsCommand } from "./hooks/useClaimsAndLegalCostsCommand";
import { useReportAccidentQuery } from "../reportRoadAccidents/hooks/useReportAccidentQuery";
import FileUploader from "../../common/components/FileUploader";

function RegisterClaimsAndLegalCosts() {
  const refInputFile = useRef(null);
  const {
    claimsAndLegalCosts,
    handleChangeClaimsAndLegalCosts,
    errors,
    createClaimsAndLegalCosts,
  } = useClaimsAndLegalCostsCommand();
  const [search, setSearch] = useState(claimsAndLegalCosts.accident || "");
  const { reportAccidents } = useReportAccidentQuery({ search, limit: 10 });

  const handleChangeFile = (file) => {
    if (file) {
      handleChangeClaimsAndLegalCosts({
        name: "legalReport",
        value: file,
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    createClaimsAndLegalCosts(claimsAndLegalCosts);
  };

  return (
    <main className="container"
    >
      <form onSubmit={handleSubmit} className="d-flex flex-column gap-3 bg-white shadow-sm">
        <section className="flex-column">
          <header className="bg-dark p-3 text-white">
            <h2 className="fs-4">Selecciona un siniestro</h2>
          </header>
          <div className="p-3">
            <SelectSearch
              name="accident"
              label="Siniestros"
              placeholder="Selecciona un siniestro"
              options={reportAccidents.map((accident) => ({
                value: accident.id,
                label: `${accident.dateAccident} - ${accident.id} - ${accident.namePersonInvolved} - ${accident.vehiclePlate}`,
              }))}
              value={claimsAndLegalCosts.accident}
              onSelect={handleChangeClaimsAndLegalCosts}
              onSearch={(text) => setSearch(text)}
              error={errors.errors.accident}
            />
          </div>
        </section>
        <section className="flex-column">
          <header className="bg-dark p-3 text-white">
            <h2 className="fs-4">Detalle de costos de siniestros</h2>
          </header>
          <div className="p-3">
            <div className="row row-cols-1 row-cols-md-2">
              <Textfield
                label="Identificacion del siniestro (IPAT)"
                placeholder="Identificacion del siniestro (IPAT)"
                name="identification"
                value={claimsAndLegalCosts.identification}
                onChange={handleChangeClaimsAndLegalCosts}
                error={errors.errors.identification}
              />
              <Textfield
                label="Fecha del movimiento contable"
                type="date"
                placeholder="Fecha del movimiento contable"
                name="accountingDate"
                value={claimsAndLegalCosts.accountingDate}
                onChange={handleChangeClaimsAndLegalCosts}
                error={errors.errors.accountingDate}
              />
              <Textfield
                label="Codigo de la cuenta"
                placeholder="Codigo de la cuenta"
                name="accountCode1"
                value={claimsAndLegalCosts.accountCode1}
                onChange={handleChangeClaimsAndLegalCosts}
                error={errors.errors.accountCode1}
              />
              <Textfield
                label="Numero del comprobante"
                placeholder="Numero del comprobante"
                name="voucherNumber"
                value={claimsAndLegalCosts.voucherNumber}
                onChange={handleChangeClaimsAndLegalCosts}
                error={errors.errors.voucherNumber}
              />
              <Textfield
                label="Nombre de identificacion del tercero"
                placeholder="Nombre de identificacion del tercero"
                name="thirdPartyIdentificationName"
                value={claimsAndLegalCosts.thirdPartyIdentificationName}
                onChange={handleChangeClaimsAndLegalCosts}
                error={errors.errors.thirdPartyIdentificationName}
              />
              <Textfield
                label="Detalle o concepto"
                placeholder="Detalle o concepto"
                name="detailConcept"
                value={claimsAndLegalCosts.detailConcept}
                onChange={handleChangeClaimsAndLegalCosts}
                error={errors.errors.detailConcept}
              />
              <Textfield
                label="Saldo inicial"
                placeholder="Saldo inicial"
                type="number"
                name="initialBalance"
                value={claimsAndLegalCosts.initialBalance}
                onChange={handleChangeClaimsAndLegalCosts}
                error={errors.errors.initialBalance}
              />
              <Textfield
                label="Movimiento credito"
                placeholder="Movimiento credito"
                type="number"
                name="creditMovement"
                value={claimsAndLegalCosts.creditMovement}
                onChange={handleChangeClaimsAndLegalCosts}
                error={errors.errors.creditMovement}
              />
              <Textfield
                label="Saldo final"
                placeholder="Saldo final"
                type="number"
                name="finalBalance"
                value={claimsAndLegalCosts.finalBalance}
                onChange={handleChangeClaimsAndLegalCosts}
                error={errors.errors.finalBalance}
              />
            </div>
          </div>
        </section>
        <section className="flex-column">
          <header className="bg-dark p-3 text-white">
            <h2 className="fs-4">Informe juridico de siniestro viales </h2>
            <p>
              En este espacio debe subir la copia del informe juridico por los
              procesos en contra de la empresa por todo tipo de siniestros
              viales incluyendo accidentes derivados de desplazamientos
              laborales y monto del fondo para accidentes si existe
            </p>
          </header>
          <div className="p-3">
            {/* <div className="upload-container">
              <input
                ref={refInputFile}
                type="file"
                id="file-upload"
                hidden
                onChange={handleChangeFile}
              />
              <label htmlFor="file-upload" className="upload-area">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="upload-icon"
                >
                  <path
                    fillRule="evenodd"
                    d="M12 2a.75.75 0 01.75.75V14.5h2.69a.75.75 0 01.53 1.28l-4 4.25a.75.75 0 01-1.06 0l-4-4.25a.75.75 0 01.53-1.28h2.69V2.75A.75.75 0 0112 2z"
                    clipRule="evenodd"
                  />
                </svg>
                <p>
                  Arrastra y suelta un archivo aquí o{" "}
                  <span>haz clic para seleccionar</span>
                </p>
              </label>
            </div> */}
            <FileUploader
              accept="application/pdf"
              value={claimsAndLegalCosts.legalReport}
              onFileChange={handleChangeFile}
              error={errors.errors.legalReport}
            />
          </div>
        </section>
        <section className="flex-column">
          <header className="bg-dark p-3 text-white">
            <h2 className="fs-4">
              Detalle de las provisiones derivadas de las demandas por
              accidentes:
            </h2>
          </header>
          <div className="p-3">
            <div className="row row-cols-1 row-cols-md-2">
              <Textfield
                label="Codigo de la cuenta"
                placeholder="Codigo de la cuenta"
                name="accountCode2"
                value={claimsAndLegalCosts.accountCode2}
                onChange={handleChangeClaimsAndLegalCosts}
                error={errors.errors.accountCode2}
              />
              <Textfield
                label="Codigo interno o numeracion del proceso"
                placeholder="Codigo interno o numeracion del proceso"
                name="internalCode"
                value={claimsAndLegalCosts.internalCode}
                onChange={handleChangeClaimsAndLegalCosts}
                error={errors.errors.internalCode}
              />
              <Textfield
                label="Fecha de demanda"
                type="date"
                placeholder="Fecha de demanda"
                name="claimDate"
                value={claimsAndLegalCosts.claimDate}
                onChange={handleChangeClaimsAndLegalCosts}
                error={errors.errors.claimDate}
              />
              <Textfield
                label="Descripcion de la demanda"
                placeholder="Descripcion de la demanda"
                name="claimDescription"
                value={claimsAndLegalCosts.claimDescription}
                onChange={handleChangeClaimsAndLegalCosts}
                error={errors.errors.claimDescription}
              />
              <Textfield
                label="Probabilidad de perdida"
                placeholder="Probabilidad de perdida"
                type="number"
                name="lossProbability"
                value={claimsAndLegalCosts.lossProbability}
                onChange={handleChangeClaimsAndLegalCosts}
                error={errors.errors.lossProbability}
              />
            </div>
          </div>
        </section>

        <footer className="w-50 mx-auto mb-3">
          <Button type="submit">Guardar</Button>
        </footer>
      </form>
    </main>
  );
}

export default RegisterClaimsAndLegalCosts;
